/*
 * @Description: 活动推广页面
 * @Author: maowy
 * @Date: 2020-02-19 14:33:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-09-Fr 04:42:14
*/

import Vue from 'vue'
import _ from 'lodash'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { Swipe, SwipeItem, Popup } from 'vant'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import officialBar from '@/components/officialBar/index.vue'
import {
    setLocalConfig,
    getLocalConfig
} from '@/utils/storage.js'
import {
    Header,
} from '@/components/customPromotion'
import ajax from '../../http/ajax'
import {
    getAllStoreList,
} from '@/models/marketingDetail'
import {
    wxShare,
} from '@/utils/wxsdk'
import { getLoginInfo } from '@/utils/loginInfo'
import InfiniteLoading from 'vue-infinite-loading'

Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Popup)

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.marketingDetail,
    components: {
        QualityImg,
        InfiniteLoading,
        Header,
        officialBar
    },
    data () {
        return {
            phone: '',
            isShowMore: false,
            isShowGoTop: false,
            isShowExplain: false,
            topic_id: '',
            sstore_id: '',
            page: 1,
            pagesize: 2,
            isPosition: false, // 是否获取当前位置
            allStoreList: [], // 全部门店
            all_store_list_count: '', // 全部门店数量
            jumpGoodsParam: {}, // 跳转商品详情请求参数
            isNoList: false, // 是否没有商品数据
            serchFixed: false, // 是否固定搜索
            ppt_goods_type: '', // 广告商品是否查询当前活动，否空 是1
            handle_floor_list: [],
            address: '',
            position: {
                longitude: '',
                latitude: ''
            },
            // 百度地图
            baidu_map: null, // 地图
            map_icon: {
                selfIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_self.png?x-oss-process=image/resize,w_22,h_30', new BMap.Size(22, 30)), // eslint-disable-line
                ohterIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_other.png?x-oss-process=image/resize,w_44,h_57', new BMap.Size(44, 57)), // eslint-disable-line
                nearIcon: new BMap.Icon('https://image.carisok.com/images/icon_map_near.png?x-oss-process=image/resize,w_44,h_57', new BMap.Size(44, 57)) // eslint-disable-line
            },
            left_bottom_latitude: '', // 地图左下角-纬度
            left_bottom_longitude: '', // 地图左下角-经度
            right_top_latitude: '', // 右上角纬度
            right_top_longitude: '', // 右上角经度
            markerArr: [], // 地图标记数组
        }
    },
    computed: {
        ...mapState({
            list: ({ marketingDetail }) => marketingDetail.data_list,
            floor_list: ({ marketingDetail }) => marketingDetail.floor_list, // 楼层的数据,
            isWeixin: ({ appInfo }) => appInfo.isWeixin
        }),
    },
    watch: {
        '$route' (to, from) {
            // 对路由变化作出响应...
            if (to.path === from.path || from.path === '/pageNotFound') {
                /* 滚动到页面顶部 */
                document.body.scrollIntoView()
                this.page = 1
                this.handle_floor_list = []
                this.markerArr = []
                this.getData()
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
                // this.infinite()
            }
        },
        isPosition (newValue) {
            if (newValue) {
                this.getAddressData()
            }
        },
    },
    created () {
        document.body.scrollIntoView()
        this.initLocation()
        this.getData()
    },
    activated () {
        const status = getLocalConfig('isChangePosition')
        if (status === '1') {
            this.initLocation()
            this.markerArr = []
            this.initBaiduMap()
            setLocalConfig('isChangePosition', '0')
        }
    },
    async mounted () {
    },
    methods: {
        ...mapActions([
            'getTopicDetail',
            'getAllStoreList',
            'getNearbySstores',
            'getMarketingFloorList',
            'getLocation',
            'getAddress',
            'addVisitLog',
            'saveAddressInfo',
        ]),
        initLocation () {
            const addressInfo = getLocalConfig('AddressInfo')
            if (addressInfo && !_.isEmpty(addressInfo)) {
                this.address = addressInfo.name
                const position = _.pick(addressInfo, ['longitude', 'latitude'])
                Object.assign(this.position, position)
                // this.isPosition = true
            }
        },
        getAddressData () {
            if (!this.address) {
                this.getAddress(Object.values(this.position))
                    .then(res => {
                        const param = {
                            longitude: this.position.longitude,
                            latitude: this.position.latitude,
                            province: res.addressComponents.province,
                            city: res.addressComponents.city,
                            district: res.addressComponents.district,
                            name: res.address || '',
                            formattedAddress: res.address
                        }
                        this.address = param.name
                        this.saveAddressInfo(param)
                    })
                this.initLocation()
                this.markerArr = []
                this.initBaiduMap()
            }
        },
        getData () {
            const { topic_id } = this.$route.query
            this.topic_id = topic_id
            this.getBasicData()
        },
        getMyLocation () {
            let that = this
            that.showLoading()
            const options = { timeout: 3000 }
            this.getLocation(options).then(this.showPosition).catch(this.showErr).finally(() => {
                this.isPosition = true
                this.hideLoading()
            })
        },
        /* 获取位置信息成功 */
        showPosition (position) {
            this.position.longitude = position.lng
            this.position.latitude = position.lat
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            this.position.longitude = 113.332926
            this.position.latitude = 23.202723
            this.setAddressInfo({
                longitude: 113.332926,
                latitude: 23.202723,
                address: '广州-同和地铁站'
            }, false)
        },
        setAddressInfo (params, successStatus = true) {
            const obj = {
                longitude: params.longitude,
                latitude: params.latitude,
                province: '广东省',
                city: '广州市',
                district: '白云区',
                name: '广州-同和地铁站',
                formattedAddress: '广州-同和地铁站'
            }
            if (!successStatus) {
                this.address = '广州-同和地铁站'
            } else {
                Object.assign(obj, params)
            }
            this.saveAddressInfo(obj)
            setLocalConfig('isChangePosition', '1')
            this.addressInfo = getLocalConfig('AddressInfo')
        },
        hasLocation () {
            if (this.position.longitude && this.position.latitude) {
                return true
            } else {
                this.getMyLocation()
                return false
            }
        },
        headerCallback (params) {
            const status = this.hasLocation()
            if (status) {
                const { type, cb } = params
                if (type === 'jump') {
                    this.goMoreFloor('')
                } else if (type === 'selectAddress') {
                    Object.assign({}, { city: this.address })
                    cb()
                }
            }
        },
        /* 获取推广基本信息 */
        async getBasicData () {
            // 请求页面数据
            this.showLoading()
            this.getTopicDetail({ topic_id: this.topic_id })
                .then(() => {
                    this.hideLoading()
                    if (Number(this.list.activity_status) === 2) {
                        this.$router.push({
                            path: '/pageNotFound',
                            query: {
                            }
                        })
                        return
                    }
                    // 配置微信的数据
                    this.configWxShare(this.list.share)
                    this.uploadLog()
                    this.$emit('setHeader', {
                        title: this.list.title || '',
                        showHeader: true,
                        showLeft: false,
                        scrollTop: ''
                    })
                    document.title = this.list.title
                    // 如果活动已经结束，当前页面显示404页面的逻辑
                    // 初始化地图
                    this.initBaiduMap()
                    // 当解释说明的高度大于90的时候出现更多字样
                    this.$nextTick(() => {
                        if (!this.$refs.info) return
                        const info = this.$refs.info
                        const infoParent = this.$refs.infoParent

                        let height = null
                        let maxHeight = null
                        if (window.getComputedStyle) {
                            // 非IE浏览器获取方法
                            height = window.getComputedStyle(info).height
                            maxHeight = window.getComputedStyle(infoParent).height
                        } else {
                            // IE浏览器获取方法
                            height = info.currentStyle['height']
                            maxHeight = infoParent.currentStyle['height']
                        }
                        if (height) {
                            String(height).split('px')[0] * 1 <= String(maxHeight).split('px')[0] * 1 ? this.isShowMore = false : this.isShowMore = true
                        }
                    })
                })
                .catch(() => {
                    this.hideLoading()
                })
            // 监听页面滚动是否出现点击去顶部的按钮
            window.addEventListener('scroll', this.scrollToTop)
        },
        infinite: _.throttle(function () {
            let params = {
                topic_id: this.topic_id,
                page: this.page,
                pagesize: this.pagesize
            }
            this.getMarketingFloorList(params).then(() => {
                if (this.floor_list.floor_infos && this.floor_list.floor_infos.length && this.floor_list.floor_infos.length === this.pagesize) {
                    this.page++
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                } else {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                }
                this.handle_floor_list = this.handle_floor_list.concat(this.floor_list.floor_infos)
                this.isNoList = _.isEmpty(this.list.main_brand_advs) && _.isEmpty(this.list.harsh_shop) && _.isEmpty(this.handle_floor_list)
            }).catch(() => {
            })
        }, 500),
        // 初始化地图
        initBaiduMap () {
            /* eslint-disable */
            // 百度地图API功能
            let _this = this
            // 初始化地图
            _this.baidu_map = new BMap.Map('allmap', { minZoom: 11 })
            let point = new BMap.Point(_this.position.longitude || '113.332926', _this.position.latitude || '23.202723')
            _this.baidu_map.centerAndZoom(point, 14)
            _this.baidu_map.disableDoubleClickZoom(true) // 禁止双击放大
            _this.baidu_map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放功能。仅对PC上有效
            // 当前定位maker
            let marker = new BMap.Marker(point, { icon: _this.map_icon.selfIcon })
            _this.baidu_map.addOverlay(marker)
            // 获取半径
            this.getBoundsCoord().then(() => {
                _this.getAllList() // 获取数据
            })
            // 滑动地图
            _this.baidu_map.addEventListener('dragend', function () {
                _this.getBoundsCoord().then(() => { // 矩形坐标
                    _this.getAllList() // 获取数据
                })
            })
            // 缩放地图
            _this.baidu_map.addEventListener('zoomend', function () {
                _this.getBoundsCoord().then(() => { // 矩形坐标
                    _this.getAllList() // 获取数据
                })
            })
            /* eslint-disable */
        },
        // 获取地图可视范围的四个角的坐标
        getBoundsCoord() {
            /* eslint-disable */
            let _this = this
            return new Promise((resolve, reject) => {
                let bounds = _this.baidu_map.getBounds() // 获取当前矩形
                let sw = bounds.getSouthWest(); // 西南角 左下
                let ne = bounds.getNorthEast(); // 东北角 右上
                // _this.left_bottom_longitude = bounds.Ul.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.Ul.lat // 左下-纬度
                // _this.right_top_longitude = bounds.Dl.lng // 右上-经度
                // _this.right_top_latitude = bounds.Dl.lat // 右上-纬度
                // _this.left_bottom_longitude = bounds.El.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.El.lat // 左下-纬度
                // _this.right_top_longitude = bounds.Vl.lng // 右上-经度
                // _this.right_top_latitude = bounds.Vl.lat // 右上-纬度
                // _this.left_bottom_longitude = bounds.Il.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.Il.lat // 左下-纬度
                // _this.right_top_longitude = bounds.Yl.lng // 右上-经度
                // _this.right_top_latitude = bounds.Yl.lat // 右上-纬度
                // _this.left_bottom_longitude = bounds.lf.lng // 左下-经度
                // _this.left_bottom_latitude = bounds.lf.lat // 左下-纬度
                // _this.right_top_longitude = bounds.of.lng // 右上-经度
                // _this.right_top_latitude = bounds.of.lat // 右上-纬度
                _this.left_bottom_longitude = sw.lng // 左下-经度
                _this.left_bottom_latitude = sw.lat // 左下-纬度
                _this.right_top_longitude = ne.lng // 右上-经度
                _this.right_top_latitude = ne.lat // 右上-纬度
                resolve()
            })
            /* eslint-disable */
        },
        // maker绘制
        getMarkerData() {
            let newMakerArr = [] // 增量标记
            if (!this.markerArr.length) { // 首次加载
                newMakerArr = this.allStoreList
            } else {
                this.allStoreList.forEach(itemArr => {
                    let obj = itemArr
                    let isExist = false
                    this.markerArr.forEach(oldMarkerArr => {
                        if (itemArr.id === oldMarkerArr.id) {
                            isExist = true
                        }
                    })
                    if (!isExist) {
                        newMakerArr.push(obj)
                    }
                })
            }
            this.markerArr = this.markerArr.concat(newMakerArr) // 把增量的数据push进来
            newMakerArr.forEach(item => {
                let point = new BMap.Point(item.longitude, item.latitude)
                let marker = new BMap.Marker(point, { icon: item.id === this.markerArr[0].id ? this.map_icon.nearIcon : this.map_icon.ohterIcon })
                this.baidu_map.addOverlay(marker)
                marker.id = item.id
                marker.addEventListener("click", (e) => {
                    this.goSpecialActivity(marker.id)// 跳转活动详情
                });
            });
        },
        /* 重置地图位置 */
        onResetMap() {
            this.baidu_map.panTo(new BMap.Point(this.position.longitude, this.position.latitude))
        },
        // 获取全部门店
        getAllList () {
            let param = {
                topic_id: this.topic_id,
                latitude: this.position.latitude,
                longitude: this.position.longitude,
                // left_bottom_latitude: this.left_bottom_latitude,
                // left_bottom_longitude: this.left_bottom_longitude,
                // right_top_latitude: this.right_top_latitude,
                // right_top_longitude: this.right_top_longitude
                left_bottom_latitude: this.right_top_latitude,
                left_bottom_longitude: this.right_top_longitude,
                right_top_latitude: this.left_bottom_latitude,
                right_top_longitude: this.left_bottom_longitude
            }
            getAllStoreList(param).then(res => {
                this.all_store_list_count = res.count
                this.allStoreList = res.list
                this.getMarkerData() // maker绘制
            })
        },
        /* 跳转门店列表 */
        goStoreList (type, map_or_list) {
            const status = this.hasLocation()
            if (!status) {
                return
            }
            this.$router.push({
                name: 'storeList',
                query: {
                    topic_id: this.topic_id,
                    latitude: this.position.latitude,
                    longitude: this.position.longitude,
                    isPosition: this.isPosition,
                    goods_id: type === 'other' ? this.jumpGoodsParam.goods_id : '',
                    spec_id: type === 'other' ? this.jumpGoodsParam.spec_id : '',
                    spu_id: type === 'other' ? this.jumpGoodsParam.spu_id : '',
                    act_id: this.thinkTime() ? this.list.activity_id : '',
                    activity_id: this.list.activity_id,
                    ppt_goods_type: this.ppt_goods_type,
                    page_code: 'marketingDetail',
                    is_map: map_or_list === 'map' ? true : false
                }
            })
        },
        uploadLog () {
            const {
                user_id = ''
            } = getLoginInfo()
            const {
                sstore_id = '',
                visitType = '',
            } = this.$route.query
            this.addVisitLog({
                sstore_id: sstore_id, // 门店id
                user_id: user_id ? Number(user_id) : 0, // 用户id (0 为未登录)
                channel: 2, // 访问渠道 (1 微养车 2 H5)
                visit_type: visitType === 2 ? 2 : 1, // 访问类型 (1普通进入 2分享链接 3扫二维码(预留))
                page_code: 'marketingDetail',
                param_type: 'activity_id',
                param_value: this.list.activity_id,
            })
        },
        /* 进入门店详情 */
        goSpecialActivity (sstore_id) {
            const status = this.hasLocation()
            if (!status) {
                return
            }
            this.$router.push({
                name: 'specialActivity',
                query: {
                    activity_id: this.list.activity_id,
                    topic_id: this.topic_id,
                    sstore_id: sstore_id,
                    latitude: this.position.latitude,
                    longitude: this.position.longitude,
                }
            })
        },
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    ...detail
                })
            }
        },
        // 判断当前时间是否超过活动时间
        thinkTime () {
            // 活动结束的时间戳
            const activity_timestamp = Number(this.list.activity_timestamp)
            // // 获取当前时间戳 -》秒
            const timestamp = (new Date()).getTime() / 1000
            return timestamp < activity_timestamp && Number(this.list.activity_status) === 1
        },
        // 查看更多解释说明
        explainMore () {
            this.isShowExplain = true
        },
        // 获取最近门店信息 ppt_goods_type 是否查询当前活动的商品 1是 0否
        getStoreDetail (spu_id, goods_type, spec_id = '', ppt_goods_type) {
            this.ppt_goods_type = ppt_goods_type || ''
            const status = this.hasLocation()
            if (!status) {
                return
            }
            let param = {
                spec_id,
                spu_id,
                goods_type,
                topic_id: this.topic_id,
                page_code: 'marketingDetail'
            }
            this.$router.push({
                name: 'moreSstoreGoodsDetail',
                query: param
            })
        },

        // 跳转外部链接之前先做判断
        activityForecast (type, source, spu_id) {
            // type为0的时候不跳转
            if (type == 0) return // eslint-disable-line
            if (type == 3) { // eslint-disable-line
                window.location.href = source
            } else if (type == 2) {// eslint-disable-line
                this.getStoreDetail(spu_id, 'agent', source, '1')
            } else if (type == 1) { // eslint-disable-line
                this.showLoading()
                ajax.post('getShopJudge', { type, source, sstore_id: '' }).then(res => {
                    this.hideLoading()
                    // 1 活动详情页面
                    if (type == 1) { // eslint-disable-line
                        this.$router.push({
                            name: 'marketingDetail',
                            query: {
                                topic_id: source
                            }
                        })
                    }
                }).catch(res => {
                    this.hideLoading()
                })
            }
        },
        // 去更多楼层事件
        goMoreFloor (floor_id) {
            const status = this.hasLocation()
            if (!status) {
                return
            }
            this.$router.push({
                name: 'goodsList',
                query: {
                    topic_id: this.topic_id,
                    latitude: this.position.latitude,
                    longitude: this.position.longitude,
                    isPosition: this.isPosition,
                    // activity_id: this.thinkTime() ? this.list.activity_id : '',
                    activity_id: this.list.activity_id,
                    floor_id,
                    page_code: 'marketingDetail'
                }
            })
        },
        // // 入驻
        // goEnter () {
        //     // 商家入驻
        //     const enterObj = {
        //         alpha: 'http://192.168.1.206/h5/iCar/openMiniSstore/index.html',
        //         beta: 'https://test-h5.carisok.com/iCar/openMiniSstore/index.html',
        //         abtest: 'https://abtest-h5.carisok.com/iCar/openMiniSstore/index.html',
        //         release: 'https://h5.carisok.com/iCar/openMiniSstore/index.html'
        //     }
        //     window.location.href = this.isWeixin
        //         ? enterObj[GLOBAL_API_ENV]
        //         // 加入枫车
        //         : 'https://www.carisok.net/join.html'
        // },
        // 点击之后页面滚到最上面
        toTop () {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 60) {
                that.isShowGoTop = true
            } else {
                that.isShowGoTop = false
            }
            if (that.scrollTop > 300) {
                that.serchFixed = true
            } else {
                that.serchFixed = false
            }
        }
    },

    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
}
